/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot, type Root } from "react-dom/client";
import { App } from "./App";
import { ErrorBoundary } from "./ErrorBoundary";
import { dict } from "./i18n";

const elem = document.getElementById("root")!;

// Pick boundary copy by browser language so a crash on first paint still
// shows a localized message. Once the app mounts, App owns the lang state.
const initialLang =
  (localStorage.getItem("lang") as "en" | "de" | null) ??
  (navigator.language?.toLowerCase().startsWith("de") ? "de" : "en");
const d = dict[initialLang];

const app = (
  <StrictMode>
    <ErrorBoundary
      labels={{
        title: d.errorTitle,
        body: d.errorBody,
        reload: d.errorReload,
      }}
    >
      <App />
    </ErrorBoundary>
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const data = import.meta.hot.data as { root?: Root };
  const root = (data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
